/**
 * Notification Dispatch Workflow Machine Config
 *
 * Spec: Documentation/Specification/04_Processes/application-agnostic/notification/NotificationDispatch.md
 * States: created → queued → dispatching → sent/failed
 */
export const notificationDispatchConfig = {
    id: 'notification-dispatch',
    initial: 'created',
    states: {
        created: {
            on: { QUEUE: 'queued' },
        },
        queued: {
            entry: { type: 'queueNotification' },
            on: { DISPATCH: { target: 'dispatching', guard: 'channelAvailable' } },
        },
        dispatching: {
            entry: { type: 'dispatchNotification' },
            on: {
                MARK_SENT: 'sent',
                MARK_FAILED: 'failed',
                RETRY: { target: 'queued', guard: 'maxRetriesNotExceeded' },
            },
        },
        sent: {
            type: 'final',
        },
        failed: {
            entry: { type: 'retryNotification' },
            on: { RETRY: { target: 'queued', guard: 'maxRetriesNotExceeded' } },
        },
    },
};
//# sourceMappingURL=notification-dispatch.js.map